import { api } from "../api";

/**
 * customerFindAllExportResponse - Function that finds on database all customers by status and export in a PDF/XSLX file  
 * /customers/{managerId}/{status}/{exportType}  
 * method GET  
 * @async-function
 */
const customerFindAllExportResponse = async (token: string, status: string, managerId: number, exportType: string, simpleXlsxExport = false) => {
    const response = await api.get(
        `/customers/${managerId}/${status}/${exportType}/export?simpleXlsxExport=${simpleXlsxExport}`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};

export default customerFindAllExportResponse;